export default "__VITE_ASSET__fa1e415a__"